import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7eb7c7fe = () => interopDefault(import('../../../pages/callback.vue' /* webpackChunkName: "pages/callback" */))
const _7b46e32e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2b060d83 = () => interopDefault(import('../../../pages/management/owners.vue' /* webpackChunkName: "pages/management/owners" */))
const _489d1f16 = () => interopDefault(import('../../../pages/management/users.vue' /* webpackChunkName: "pages/management/users" */))
const _3ecb2643 = () => interopDefault(import('../../../pages/forms/_code.vue' /* webpackChunkName: "pages/forms/_code" */))
const _0f743484 = () => interopDefault(import('../../../pages/persons/_country/index.vue' /* webpackChunkName: "pages/persons/_country/index" */))
const _4664f028 = () => interopDefault(import('../../../pages/persons/_country/_id.vue' /* webpackChunkName: "pages/persons/_country/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/callback",
    component: _7eb7c7fe,
    name: "callback___en"
  }, {
    path: "/es",
    component: _7b46e32e,
    name: "index___es"
  }, {
    path: "/es/callback",
    component: _7eb7c7fe,
    name: "callback___es"
  }, {
    path: "/management/owners",
    component: _2b060d83,
    name: "management-owners___en"
  }, {
    path: "/management/users",
    component: _489d1f16,
    name: "management-users___en"
  }, {
    path: "/es/management/owners",
    component: _2b060d83,
    name: "management-owners___es"
  }, {
    path: "/es/management/users",
    component: _489d1f16,
    name: "management-users___es"
  }, {
    path: "/",
    component: _7b46e32e,
    name: "index___en"
  }, {
    path: "/es/forms/:code?",
    component: _3ecb2643,
    name: "forms-code___es"
  }, {
    path: "/es/persons/:country",
    component: _0f743484,
    name: "persons-country___es"
  }, {
    path: "/es/persons/:country?/:id",
    component: _4664f028,
    name: "persons-country-id___es"
  }, {
    path: "/forms/:code?",
    component: _3ecb2643,
    name: "forms-code___en"
  }, {
    path: "/persons/:country",
    component: _0f743484,
    name: "persons-country___en"
  }, {
    path: "/persons/:country?/:id",
    component: _4664f028,
    name: "persons-country-id___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
